// extracted by mini-css-extract-plugin
export const wrapper = "intro-module--wrapper--2o7yt";
export const skewed = "intro-module--skewed--2I26-";
export const container = "intro-module--container--1i-hK";
export const title = "intro-module--title--MJzTU";
export const subtitle = "intro-module--subtitle--BzwGG";
export const bio = "intro-module--bio--1dkts";
export const contentWrapper = "intro-module--contentWrapper--1m8M8";